// date-fns uses 'en-US' locale by default, no global configuration needed
const configureMoment = () => {
  // No-op: kept for backwards compatibility
}

export default configureMoment
